import * as yup from "yup";

export const schemaIndex = yup.object().shape({
  category: yup
    .string()
    .transform((value) => (!value ? null : value))
    .nullable(true),
  title: yup
    .string()
    .transform((value) => (!value ? null : value))
    .nullable(true),
});

export const schemaShow = yup.object().shape({
  name: yup
    .string()
    .min(3, "Minimum 3 characters")
    .required("Name is required"),
  type: yup.string().required("Type is required"),
  info: yup
    .object()
    .typeError("notValidJSON")
    .shape({
      tries: yup.number().typeError("tries invalid type").required(),
      timeout: yup.number().typeError("timeout invalid type").required(),
      triesAnswer: yup
      .string()
      .typeError("triesAnswer invalid type")
      .required(),
      timeoutAnswer: yup
        .string()
        .typeError("timeoutAnswer invalid type")
        .required(),
      unrecognizedAnswer: yup
        .string()
        .typeError("unrecognizedAnswer invalid type")
        .required(),
      endAnswer: yup
      .string()
      .typeError("endAnswer invalid type"),
      questions: yup
        .array()
        .typeError("questions invalid type")
        .of(
          yup
            .object()
            .typeError("questions invalid type")
            .shape({
              text: yup.lazy((value) => {
                switch (typeof value) {
                  case "object":
                    return yup
                      .object()
                      .typeError("text invalid type")
                      .shape({
                        question: yup
                          .string()
                          .typeError("question invalid type")
                          .required(),
                        items: yup
                          .array()
                          .typeError("items invalid type")
                          .of(
                            yup
                              .object()
                              .typeError("items invalid type")
                              .shape({
                                answers: yup
                                  .array()
                                  .typeError("answers invalid type")
                                  .required(),
                                default: yup
                                  .boolean()
                                  .typeError("default invalid type"),
                                optionText: yup
                                  .string()
                                  .typeError("optionText invalid type")
                                  .required(),
                              })
                          )
                          .required(),
                      })
                      .required();
                  case "string":
                    return yup
                      .string()
                      .typeError("text invalid type")
                      .required();
                  default:
                    return yup.mixed();
                }
              }),
              type: yup.string().typeError("type invalid type").required(),
              label: yup.string().typeError("label invalid type").required(),
            })
        )
        .required(),
    })
    .required("Info is required"),
});
